import Immutable from 'seamless-immutable';
import _ from 'lodash';
import DrawModel from './draw-model';

function create(draws = []) {
  return Immutable(_.map(draws, DrawModel.create));
}

function deserialize(draws = []) {
  return Immutable(_.map(draws, DrawModel.deserialize));
}

export default {
  create,
  deserialize,
};
